import { PageSkeleton } from "#components/pages";
import { ARTISTS_OR_CREATORS, SITE_NAME } from "#env/env-vars";
import { MouseEvent, useState } from "react";
import { fetchFavoritePosts, fetchFavoriteProfiles } from "#api/account/favorites";

import * as styles from "./styles.module.scss";
import clsx from "clsx";

export function FavoritesExportPage() {
  const [loading, setLoading] = useState(false);
  const [favoriteJSON, setFavoriteJSON] = useState<string | null>(null);

  async function onClick() {
    try {
      setLoading(true);
      let favorites = await exportFavorites();
      setFavoriteJSON(JSON.stringify(favorites));
    } finally {
      setLoading(false);
    }
  }

  async function copyToClipboard(event: MouseEvent) {
    if (favoriteJSON && window.navigator.clipboard) {
      await navigator.clipboard.writeText(favoriteJSON);
      let button = event.target as HTMLButtonElement;
      if (button) {
        button.disabled = true;
        setTimeout(() => button.disabled = false, 500);
      }
    }
  }

  return (
    <PageSkeleton name="favorites" title="Export Favorites" heading="Export Favorites" className={styles.exportPage}>
      <div>
        <p>
          If you'd like, you can click the button below to export your favorites to JSON format.
          This will only export the metadata from {SITE_NAME}, not the files themselves.
        </p>

        <button className="button" onClick={onClick} disabled={loading}>
          {loading ? "Loading..." : "Export Favorites"}
        </button>

        {favoriteJSON && (
          <>
            <textarea value={favoriteJSON} readOnly={true}>
            </textarea>
            {window.navigator.clipboard && (
              <button className={clsx("button", styles.copyButton)} onClick={copyToClipboard}>
                <span className={styles.copyText}>Copy</span>
                <span className={styles.copyImage}>
                  Copied
                </span>
              </button>
            )}
          </>
        )}
      </div>
    </PageSkeleton>
  );
}

async function exportFavorites() {
  let [posts, profiles] = await Promise.all([fetchFavoritePosts(), fetchFavoriteProfiles()]);

  return {
    posts,
    [ARTISTS_OR_CREATORS.toLowerCase()]: profiles,
  };
}
